import { Route, Routes } from "react-router-dom";

import { FolioDetailPage } from "@/routes/FolioDetailPage";
import { HomePage } from "@/routes/HomePage";
import { NotFoundPage } from "@/routes/NotFoundPage";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/folio/:id" element={<FolioDetailPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
